import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  headline: "",
}

const whatsappModalSlice = createSlice({
  name: "whatsappModal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
      state.headline = action.payload
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.headline = "";
    }
  }
})

export const {openModal, closeModal} = whatsappModalSlice.actions;
export default whatsappModalSlice.reducer;

